module.exports = __webpack_public_path__ + "img/stor_wrapbg7.736cfa2d.png";